import React, {forwardRef} from 'react'

import OptionPill from "./option-pill"
import OptionText from "./option-text"

type Props = {
    option          : Option

    isHighlighted   : boolean
    isSelected      : boolean

    onClick         : func
}

// extends React.Component is required because of reference in parent
const SelectMultiGenericPopoverOption = forwardRef((props: Props, ref: any) => {

    const onClick = () => {props.onClick(props.option)}

    const RenderComponent = !!props.option.color ? OptionPill : OptionText
    return <RenderComponent {...props} onClick={onClick}/>
})

export default SelectMultiGenericPopoverOption